import { render, staticRenderFns } from "./schDormitory.vue?vue&type=template&id=e547870e&scoped=true&"
import script from "./schDormitory.vue?vue&type=script&lang=js&"
export * from "./schDormitory.vue?vue&type=script&lang=js&"
import style0 from "./schDormitory.vue?vue&type=style&index=0&id=e547870e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e547870e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
